export function getDataObjectById (dataObjects, id) {
  for (const dataObject of dataObjects) {
    if (dataObject.id === id) {
      return dataObject
    }
  }
  return null
}
